import { store } from 'store';

const config = {
  transportPolicy: 'relay',
  iceServers: [
    {
      urls: ['stun:fr-turn1.xirsys.com']
    },
    {
      username:
        'OYLGHaRzZUwcaWgJQfJC79pTHhKpfY_b__Cl0psV8y3l_WMCYgCxwaM6Rx0k3Q7nAAAAAGIWC9tjZXlodW5hbGF0dGU=',
      credential: '13eff550-9493-11ec-bac1-0242ac120004',
      urls: [
        'turn:fr-turn1.xirsys.com:80?transport=udp',
        'turn:fr-turn1.xirsys.com:3478?transport=udp',
        'turn:fr-turn1.xirsys.com:80?transport=tcp',
        'turn:fr-turn1.xirsys.com:3478?transport=tcp',
        'turns:fr-turn1.xirsys.com:443?transport=tcp',
        'turns:fr-turn1.xirsys.com:5349?transport=tcp'
      ]
    }
  ]
};

let myConn = null,
  local = null,
  clients = {};

async function localStream() {
  myConn = new RTCPeerConnection(config);

  const stream = await navigator.mediaDevices
    .getUserMedia({
      audio: true,
      video: {
        frameRate: 20,
        height: 576,
        width: 1024,
        facingMode: 'user'
      }
    })
    .then((stream) => {
      return stream;
    })
    .catch((error) => {
      // Log error
      console.log('Local Error: ', error);
    });

  if (!stream) return null;

  stream.getTracks().forEach((track) => myConn.addTrack(track, stream));
  local = stream;

  store.dispatch({
    type: 'UPDATE_STREAMING',
    payload: {
      local: stream,
      myConn
    }
  });

  return true;
}

function sendOffer({ offerTo, currentUserName }) {
  delete clients[offerTo];

  const newPeer = new RTCPeerConnection(config);
  clients[offerTo] = newPeer;

  local.getTracks().forEach((track) => newPeer.addTrack(track, local));

  newPeer
    .createOffer({ iceRestart: true })
    .then((sdp) => newPeer.setLocalDescription(sdp))
    .then(() => {
      // send the offer to every other user
      global.socket.send('newOffer', {
        offerFrom: currentUserName,
        offerTo: offerTo,
        offer: newPeer.localDescription
      });
    })
    .catch((e) => console.log('err create offer', e));

  newPeer.onicecandidate = (e) => {
    if (!e.candidate) return;
    global.socket.send('iceCandidate', {
      to: offerTo,
      sender: currentUserName,
      candidate: e.candidate
    });
  };

  newPeer.ontrack = (e) => {
    newPeer[e.track.kind === 'video' ? 'videoTrack' : 'audioTrack'] = e.streams[0];

    store.dispatch({
      type: 'UPDATE_STREAMING',
      payload: { clients }
    });
  };

  newPeer.oniceconnectionstatechange = (e) => {
    const connState = newPeer.iceConnectionState;
    console.log('sendOffer connState', connState);

    store.dispatch({
      type: 'UPDATE_STREAMING',
      payload: { clients }
    });

    // if(clients[offerTo]) clients[offerTo].close()
    // console.log('disconn log', clients[offerTo])
    // delete clients[offerTo]
    //
    // store.dispatch({
    //   type: 'UPDATE_STREAMING',
    //   payload: { clients }
    // })
  };
}

function onOffer({ offer, offerFrom, currentUserName }) {
  delete clients[offerFrom];

  let newPeer = new RTCPeerConnection(config);
  clients[offerFrom] = newPeer;

  local.getTracks().forEach((track) => newPeer.addTrack(track, local));

  newPeer
    .setRemoteDescription(new RTCSessionDescription(offer))
    .then(() => newPeer.createAnswer())
    .then((sdp) => newPeer.setLocalDescription(sdp))
    .then(() => {
      global.socket.send('newAnswer', {
        answerFrom: currentUserName,
        answerTo: offerFrom,
        offer: newPeer.localDescription
      });
    })
    .catch((e) => console.log('err onOffer', e, offer));

  newPeer.onicecandidate = (e) => {
    if (!e.candidate) return;
    global.socket.send('iceCandidate', {
      to: offerFrom,
      sender: currentUserName,
      candidate: e.candidate
    });
  };

  newPeer.ontrack = (e) => {
    newPeer[e.track.kind === 'video' ? 'videoTrack' : 'audioTrack'] = e.streams[0];

    store.dispatch({
      type: 'UPDATE_STREAMING',
      payload: { clients }
    });
  };

  newPeer.oniceconnectionstatechange = (e) => {
    const connState = newPeer.iceConnectionState;
    console.log('onOffer connState', connState);

    store.dispatch({
      type: 'UPDATE_STREAMING',
      payload: { clients }
    });
  };
}

function onAnswer({ answerFrom, offer, currentUserName }) {
  clients[answerFrom].setRemoteDescription(new RTCSessionDescription(offer));

  clients[answerFrom].isReady = true;

  store.dispatch({
    type: 'UPDATE_STREAMING',
    payload: { clients }
  });
}

function addIceCandidate({ sender, candidate }) {
  if (clients[sender]) {
    clients[sender].addIceCandidate(new RTCIceCandidate(candidate));

    clients[sender].isReady = true;

    store.dispatch({
      type: 'UPDATE_STREAMING',
      payload: { clients }
    });
  }
}

function toggleMute() {
  local.getAudioTracks().forEach((track) => {
    track.enabled = !track.enabled;
  });
}

function toggleVideo() {
  local.getVideoTracks().forEach((track) => {
    track.enabled = !track.enabled;
  });
}

function close() {
  if (!myConn) return;

  // CLOSE CONN FOR EACH PEER
  Object.keys(clients).forEach((x) => clients[x].close());
  // CLOSE CONN FOR SELF
  myConn.close();

  // STOP LOCAL STREAM
  local.getTracks().forEach((track) => {
    track.stop();
  });

  clients = {};
  myConn = undefined;
  local = undefined;

  store.dispatch({
    type: 'UPDATE_STREAMING',
    payload: {
      clients: {},
      myConn: undefined,
      local: undefined
    }
  });
}

function hangUp({ userName }) {
  clients[userName]?.close();
  delete clients[userName];

  store.dispatch({
    type: 'UPDATE_STREAMING',
    payload: { clients }
  });
}

const exports = {
  localStream,
  sendOffer,
  onOffer,
  onAnswer,
  addIceCandidate,
  close,
  local,
  clients,
  hangUp,
  toggleMute,
  toggleVideo
};

export default exports;
